module.exports = __webpack_public_path__ + "static/media/ORACIÓN-PRESENCIAL_FULLLIFECONÉCTATE.37a69851.png";